<template>
    <ul class="list-group">
        <li class="list-group-item flex-column align-items-start tarief">
            <div class="d-flex justify-content-between">
                <a
                    role="button"
                    class="tarief-intro icon-plus"
                    @click="addRate"
                >
                    <span>Nieuw tarief</span>
                    <span class="alt"
                        >Bijvoorbeeld een tweede tarief of overuren</span
                    >
                </a>
            </div>
        </li>
    </ul>
</template>
<script>
import EventBus from '@/shared/VueEvent';

export default {
    methods: {
        addRate: function () {
            EventBus.fire('addRate');
        }
    }
};
</script>
